import { getStoredSessionToken } from '../../../app/services/session.service';

const API_BASE_URL = (process.env.REACT_APP_DEALS_API_BASE_URL || '').replace(/\/$/, '');
const API_PATH = '/api/deals/custom-fields';

function authHeaders(extraHeaders = {}) {
  const token = getStoredSessionToken();
  return token ? { ...extraHeaders, Authorization: `Bearer ${token}` } : extraHeaders;
}

function readPayload(response) {
  return response.json().catch(() => null);
}

function result(ok, data = null, error = null, message = '') {
  return { ok, data, error, message };
}

function url(formKey, suffix = '') {
  return `${API_BASE_URL}${API_PATH}/${encodeURIComponent(formKey)}${suffix}`;
}

export async function listDealsCustomFields(formKey) {
  const response = await fetch(url(formKey), { headers: authHeaders() });
  const payload = await readPayload(response);
  if (!response.ok) throw new Error(payload?.message || 'Campi personalizzati non disponibili.');
  return Array.isArray(payload) ? payload : [];
}

export async function createDealsCustomField(definition, formKey) {
  const response = await fetch(url(formKey), { method: 'POST', headers: authHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify(definition) });
  const payload = await readPayload(response);
  return response.ok ? result(true, payload) : result(false, null, 'CUSTOM_FIELD_CREATE_FAILED', payload?.message || 'Impossibile salvare il campo.');
}

export async function archiveDealsCustomField(id, formKey) {
  const response = await fetch(url(formKey, `/${encodeURIComponent(id)}`), { method: 'DELETE', headers: authHeaders() });
  const payload = await readPayload(response);
  return response.ok ? result(true) : result(false, null, 'CUSTOM_FIELD_ARCHIVE_FAILED', payload?.message || 'Impossibile archiviare il campo.');
}
